import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import { TextField } from '@mui/material';
import { Button } from '@mui/material';import { makeStyles } from '@mui/styles';
import { get } from 'lodash';
import Text from '../../../components/typography'
import { theme } from '../../../themes/default-theme';
import { Cta } from '../../../components/ui';
import searchIcon from '../../../assets/icons/model-postcode-search.svg';
import Modal from '../../../components/ui/Modal';
import { Loader } from 'google-maps';
import getClosestCoordinate from '../../../../src/util/getClosestCoodinate';
import getClosestDealersByPostcode from '../../../util/getClosestDealersByPostcode';
import getFallbackStateAus from '../../../util/getFallbackStateAus';
import postcodeRefactor from '../../../util/postcodeRefactor';
import refactorDealerData from '../../../../src/data-restructure/pages/dealer'
import getClosestDealer from '../../../../src/util/getClosestDealer';
import { useRouter } from 'next/router';

const FormHeader = styled.div`
h3 {
    font-weight: 800;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 20px;
    color: #2E3238;
}
> div {
    font-size: 16px;
    line-height: 23px;
    color: #758094;
}
${theme.breakpoints.up('md')} {
    margin-bottom: 25px;
}
${theme.breakpoints.down('sm')} {
    margin-bottom: 20px;
}
`

const Input = styled.div`
  margin: 10px 0;
  text-align: left;
  + h6 {
    margin: 20px 0;
    font-size: 15px;
    line-height: 21px;
    color: #010101;
  }
  > p {
    font-size: small;
  }
  ${theme.breakpoints.up('md')} {
    margin: 12px 0;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 15px 0;
  }
`

const Or = styled(Text)`

`

const PostCodeInput = styled(TextField)`
  width: 100%;

  input {
    padding-right: 45px;
    ${theme.breakpoints.down('md')} {
      /* iOS Safari zooms in on inputs with font-size below 16px, so we render at 16px and scale it back down to match the theme's 14px mobile size */
      font-size: 16px;
      width: 114.29%;
      transform: scale(0.875);
      transform-origin: left center;
    }
  }
`

const SetLocationWrapper = styled.span`
  ${props => !props.isEnabled && `
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  `}
`

const SetLocation = styled(Cta)`
  min-width: 250px;
  font-weight: 700;
  font-size: 15px;
  line-height: 21px;
  color: #0170D4;
  padding: 13px 30px;
  text-transform: uppercase;
`

const Error = styled.p`
  // position: absolute;
  margin: 5px;
`

const PostCodeInputContainer = styled.div`
  position: relative;
`

const SubmitIcon = styled.img`
  width: 20px;
  height: 20px;
  display: block;

  ${theme.breakpoints.down('sm')} {
    width: 12px;
    height: 12px;
  }
`
const Submit = styled(Button)`
  border-radius: 30px;
  min-width: auto;
  color: ${theme.palette.white};
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);

  ${theme.breakpoints.down('sm')} {
    width: 26px;
    height: 26px;
    right: 10px;
  }
`

const Continue = styled.div`
    margin-top: 25px;
    padding-top: 25px;
    border-top: 1px solid ${theme.palette.middleGrey};
    button {
        max-width: 200px;
        float: right;
        font-size: 15px;
        line-height: 21px;
        font-weight: 700;
    }
`

const newPostcodePopupDefaultPropDealers = [];
const newPostcodePopupDefaultPropPostcodeStatus = () => {};
const newPostcodePopupDefaultPropGetCurrentSetLocation = () => {};

const NewPostcodePopup = (props) => {
    props = {
        ...props,
        dealers: typeof props.dealers === "undefined" ? newPostcodePopupDefaultPropDealers : props.dealers,
        postcode: typeof props.postcode === "undefined" ? '' : props.postcode,
        postcodeStatus: typeof props.postcodeStatus === "undefined" ? newPostcodePopupDefaultPropPostcodeStatus : props.postcodeStatus,
        getCurrentSetLocation: typeof props.getCurrentSetLocation === "undefined" ? newPostcodePopupDefaultPropGetCurrentSetLocation : props.getCurrentSetLocation,
        staticData: typeof props.staticData === "undefined" ? false : props.staticData
    };

    const {
        dealers,
        countryProps,
        postcodeStatus,
        getCurrentSetLocation,
        staticData
    } = props

    const [postcodeError, setPostcodeError] = useState(false);
    const [postcode, setPostcode] = useState(props.postcode);
    const [locationBtnActive, setLocationBtn] = useState(true);
    const [gettingLocation, isGettingLocation] = useState(false);
    const [open, setOpen] = useState(true);
    const router = useRouter();

    // Methods Start

    const dealerUri = '/dealer/';
    const countryCode = countryProps.countryCode;
    const [filteredDealers, setFilteredDealers] = useState(dealers);
    const [geocoder, setGeocoder] = useState(null);

    const getGeoDealerFromPostcode = (postcode) => {

        const country = countryProps.countryCode === 'AU' ? 'Australia' : 'New Zealand'
        const fallback = get(filteredDealers[0], 'acf_dealers.country') === 'Australia' ? getFallbackAus(postcode) : getFallbackNz(postcode);

        geocoder.geocode({ 'address': 'postalcode+' + postcode + country }, (results, status) => {
            if (status == 'OK') {
                const latFunc = get(results, '[0].geometry.location.lat', null)
                const lngFunc = get(results, '[0].geometry.location.lng', null)

                if (latFunc && lngFunc) {
                    const latLng = {
                        latitude: latFunc(),
                        longitude: lngFunc()
                    }

                    const closest = getClosestCoordinate(latLng, filteredDealers.map(item => {
                        return {
                            ...item,
                            longitude: parseFloat(get(item, 'acf_dealers.longitude', '')),
                            latitude: parseFloat(get(item, 'acf_dealers.latitude', '')),
                        }
                    }), filteredDealers);

                    if (closest && closest.item && closest.item.uri) {
                        // Router.push(dealerUri + closest.item.uri).then(() => window.scrollTo(0, 0));
                        saveDealer(closest);
                        router.reload();
                    } else {
                        // fallback && fallback.uri && Router.push(dealerUri + fallback.uri).then(() => window.scrollTo(0, 0));
                        saveDealer(fallback)
                    }
                }
            } else {
                saveDealer(fallback);
                router.reload();
            }
        });
    }

    const getFallbackAus = (post_code) => {
        return getFallbackStateAus(post_code, filteredDealers);
    }

    const getFallbackNz = (post_code) => {
        const postcode = parseInt(post_code);
        const closestDealer = getClosestDealersByPostcode(postcode, filteredDealers, 1);
        return closestDealer[0]
    }

    const saveDealer = (dealer) => {
        const data = dealer && dealer.item ? dealer.item : dealer
        const refactoredData = refactorDealerData(data);
        // console.log(dealer)
        // if dealer is sales then save to LS
        if (get(data, 'acf_dealers.sales', '') === '1') {
            data && localStorage.setItem('buildPriceDealer', JSON.stringify({
                title: data.title,
                uri: data.uri,
                data: refactoredData
            }));

        }
    }

    const getDealerFromPostcode = (_postcode) => {

        let postcode = _postcode;

        const postcodeFromTo = postcodeRefactor

        postcodeFromTo.forEach(item => {
            if (item.from === _postcode.toString()) {
                postcode = item.to
            }
        })

        const closestDealer = getClosestDealer(postcode, filteredDealers, countryCode);
        if (closestDealer) {
            // closestDealer.uri && Router.push(dealerUri + closestDealer.uri).then(() => window.scrollTo(0, 0));
            saveDealer(closestDealer)
        } else {
            getGeoDealerFromPostcode(postcode);
        }

    }

    const getDealerFromLocation = (location) => {
        const closest = getClosestCoordinate(location, dealers.map(item => {
            return {
                ...item,
                longitude: parseFloat(get(item, 'acf_dealers.longitude', '')),
                latitude: parseFloat(get(item, 'acf_dealers.latitude', '')),
            }
        }), filteredDealers);
        if (closest && closest.item && closest.item.uri) {
            saveDealer(closest);
            router.reload();
        } else {
            const fallback = get(filteredDealers[0], 'acf_dealers.country') === 'Australia' ? getFallbackStateAus(postcode, filteredDealers) : filteredDealers[0];
            saveDealer(fallback);
            router.reload();
        }
    }
    const onSubmit = (location, type) => {
        if (type === 'postcode') {
            const postcode = get(location, 'postcode', null)
            postcode && getDealerFromPostcode(postcode)
        } else {
            getDealerFromLocation(location);
        }
    }

    const handlePostcodeKeyup = (e) => {
        if (postcode.length === 4 && e.keyCode == 13) {
            handleSubmit();
            return
        }
        if (e.keyCode === 13) {
            setPostcodeError(true)
        }
    }

    const handleSubmit = () => {
        if (postcode.length !== 4) {
            setPostcodeError(true)
        } else {
            setPostcodeError(false)
            const userLocation = window.localStorage.userLocation ? JSON.parse(window.localStorage.userLocation) : {}
            const location = {
                postcode
            }
            const data = {
                ...userLocation,
                ...location
            }
            localStorage.setItem('userLocation', JSON.stringify(data));
            onSubmit(data, 'postcode');
            setOpen(false);
            postcodeStatus();
        }
        getCurrentSetLocation(typeof window != 'undefined' && window.localStorage.getItem('buildPriceDealer'));
    }

    const handlePostcodeChange = (e) => {
        const val = e.target.value;
        if (!isNaN(val) && val.length <= 4) {
            setPostcode(val);
        }
    }

    const getCurrentLocation = () => {
        if (navigator.geolocation) {
            isGettingLocation(true);
            navigator.geolocation.watchPosition(showPosition, () => {
                setLocationBtn(false);
                isGettingLocation(false);
            });
        } else {
            setLocationBtn(false);
        }
    }

    const showPosition = (position) => {
        const localStorage = window.localStorage;
        const location = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
        }
        const userLocation = window.localStorage.userLocation ? JSON.parse(window.localStorage.userLocation) : {}
        const data = {
            ...userLocation,
            ...location
        }
        localStorage.setItem('userLocation', JSON.stringify(data));
        isGettingLocation(false);
        setLocationBtn(true);
        onSubmit(data, 'location')
    }
    // Methods End

    // Effect Start
    useEffect(() => {
        const userLocation = JSON.parse(get(window, 'localStorage.userLocation', '{}'));

        if (userLocation.postcode && props.postcode !== '') {
            setPostcode(userLocation.postcode);
        }

    }, [])

    useEffect(() => {
        const asyncLoad = async () => {
            const loader = new Loader(process.env.GOOGLE_MAPS_API_KEY, {});
            const google = await loader.load();
            setGeocoder(new google.maps.Geocoder())
        }
        asyncLoad()
    }, [])

    useEffect(() => {
        setFilteredDealers(dealers);
    }, [dealers])

    useEffect(() => {

        const _filteredDealers = dealers;

        setFilteredDealers(_filteredDealers);
    }, [])

    // Effect End

    const useStyles = makeStyles(() => ({
        modalOverlay: {
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
                paddingRight: 0,
            }
        },
        content: {
            position: 'relative',
            zIndex: 1001,
            display: 'inline-block',
            verticalAlign: 'middle',
            width: '100%',
            maxWidth: '544px',
            margin: 'auto',
            background: '#F3F4F7',
            [theme.breakpoints.up('md')]: {
                padding: '35px 45px'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '20px'
            }
        },
        modalInner: {
            width: '100%',
            display: 'inline-block',
            maxWidth: 1254,
        },
        modalClose: {
            top: '20px',
            right: '20px',
            position: 'fixed',

        }
    }));

    const classes = useStyles();
    // console.log(typeof window != 'undefined' && window.localStorage.getItem('userLocation'))
    // console.log(typeof window != 'undefined' && window.localStorage.getItem('dealer'))
    // console.log('postcode', postcode)
    return (
        !staticData &&
            <Modal
                isOpen={open}
                onClose={() => {
                    setOpen(false);
                    postcodeStatus();
                    }
                }
                overlayClassname={classes.modalOverlay}
                innerClassname={classes.modalInner}
                closeClassname={classes.modalClose}
                contentClassname={classes.content}
                backdropBackground={'rgba(46, 50, 56, 0.8)'}
                iconVividBlue={true}
            >
                <FormHeader>
                    <Text variant="h3" uppercase align="center">Enter Your location</Text>
                    <Text variant="body2" align="center">Please enter your postcode so we can provide you with location specific pricing and information</Text>
                </FormHeader>
                <Input>
                    <PostCodeInputContainer>
                        <PostCodeInput
                            placeholder={'Postcode'}
                            value={postcode}
                            onChange={(e) => handlePostcodeChange(e)}
                            onKeyUp={handlePostcodeKeyup}
                            error={postcodeError}
                            variant="outlined"
                            type="tel"
                        />
                        <Submit onClick={handleSubmit}>
                            <SubmitIcon src={searchIcon} alt="search" />
                        </Submit>
                    </PostCodeInputContainer>
                </Input>
                <>
                    <Or variant="subtitle1" uppercase align="center">Or</Or>
                    <Input>
                        <SetLocationWrapper
                            isEnabled={locationBtnActive}
                        >
                            <SetLocation
                                onClick={getCurrentLocation}
                                outline>{gettingLocation ? 'Getting location...' : 'Use my location'}</SetLocation>
                        </SetLocationWrapper>
                        {!locationBtnActive &&
                            <Error>Browser location is blocked.<br />Please update your browser settings.</Error>
                        }
                    </Input>
                    <Continue>
                        <Cta primary uppercase onClick={handleSubmit}>
                            Continue
                        </Cta>
                    </Continue>
                </>
            </Modal>
    

    )
}

NewPostcodePopup.propTypes = {
    dealers: propTypes.array,
    postcode: propTypes.string,
    postcodeStatus: propTypes.func,
    getCurrentSetLocation: propTypes.func,
    staticData: propTypes.bool
}

export default NewPostcodePopup